import {Injectable} from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class SoundService {
  private quietSound = new Audio('assets/sounds/quiet.mp3');
  private loudSound = new Audio('assets/sounds/loud.mp3');

  constructor() {
  }

  public playQuiet() {
    this.quietSound.play();
  }

  public playLoud() {
    this.loudSound.play();
  }
}
